export interface AnnouncementUI {
  hideDayTrigger: boolean
  hideRoomTypeTrigger: boolean
  hideRoadTrigger: boolean
  hideCheapestTrigger: boolean
  hideNiceOneTrigger: boolean
  hideMultiCityTrigger: boolean
  lastDismissedCrowdFund: Date | null
}

export const initAnnouncement: AnnouncementUI = {
  hideDayTrigger: false,
  hideRoomTypeTrigger: false,
  hideRoadTrigger: false,
  hideCheapestTrigger: false,
  hideNiceOneTrigger: false,
  hideMultiCityTrigger: false,
  lastDismissedCrowdFund: null,
}
